module.exports = __webpack_public_path__ + "static/media/bmc_logo.87592b47.png";